export const defaultTitle = 'Your title goes here';
export const defaultDescription = 'Your description goes here';

export const ENPS = 'enps';
export const DROP_DOWN = 'dropDown';
export const ICON = 'icon';
export const MULTIPLE_CHOICE = 'multipleChoice';
export const NEW_MESSAGE = 'newMessage';
export const RATING = 'rating';
export const TEXT = 'text';
export const YES_NO = 'yesNo';

export const SLIDE_TIMING = 750;

export const NPS = 'NPS';
export const YES_NO_ICON_PATH = 'yes_no';
export const NPS_PROMOTERS_INDEX = [9, 10];
export const NPS_DETRACTORS_INDEX = [0, 1, 2, 3, 4, 5, 6];

export const COLORS = {
  MAIN: '#14a5b2',
  POSITIVE: '#219653',
  NEUTRAL: '#f8e67e',
  NEGATIVE: '#c23628',
  BLACK: '#000000',
  WHITE: '#ffffff',
};
